import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Helmet from "react-helmet";

// containers
import HomePage from "./containers/HomePage";
import InteriorPage from "./containers/InteriorPage";
import SingleBeer from "./containers/SingleBeer";
import BeerArchive from "./containers/BeerArchive";
import InfoPage from "./containers/InfoPage";

// components
import Header from "./components/header/index";
import Footer from "./components/footer/index";

// tracking
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";

// styles
import "./css/app.scss";
import baileson from "./assets/jpg/baileson.jpg";
import registerServiceWorker from "./registerServiceWorker";

if (window.location.hostname !== `localhost`) {
  // initialize google analytics
  ReactGA.initialize("UA-125268887-1");
  ReactGA.pageview(window.location.pathname);

  // initialize facebook pixel
  ReactPixel.init("551876558585026");
  ReactPixel.pageView();
}

const App = withRouter(({ location }) => {
  return (
    <React.Fragment>
      <Helmet>
        <meta property="og:url" content={window.location} />
        <meta property="og:title" content="Baileson Brewing" />
        <meta property="og:description" content="Man's other best friend." />
        <meta property="og:image" content={window.location.origin + baileson} />
      </Helmet>
      <Header />
      <TransitionGroup>
        <CSSTransition key={location.key} classNames="fade" timeout={500}>
          <Switch location={location}>
            <Route exact path="/" component={HomePage} />
            <Route path="/faq" component={InfoPage} />
            <Route path="/beer/:name" component={SingleBeer} />
            <Route path="/beers" component={BeerArchive} />
            <Route path="/:slug" component={InteriorPage} />
          </Switch>
        </CSSTransition>
      </TransitionGroup>
      <Footer />
    </React.Fragment>
  );
});

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js